<template>
  <div class="">
    <div v-if="isAdv" class="adv-box">
      <div class="adv-top ys-icon"></div>
      <div class="adv-main">
        <div class="hz-main"></div>
      </div>
    </div>
    <div class="cus">
      <h2>客户服务</h2>
      <p>客服热线：4000666122(工作日9:00-18:00)</p>
    </div>
    <div class="qrcode-box">
      <div class="qrcode-main"></div>
    </div>
    <div class="footer">Copyright © 169 2017 - 2018 Diandian 点点版权所有 <a href="https://beian.miit.gov.cn">粤ICP备17079095号</a> 深圳众联商务有限公司</div>
  </div>
</template>
<style lang="scss" scoped>
</style>
<script>
export default {
  data() {
    return {
      footerText:
        "Copyright &#169 2017 - 2018 Diandian<br /> 点点版权所有 粤ICP备17079095号-2",
    };
  },
  props: {
    isAdv: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    if (window.location.host == "www.bepoint.cn") {
      this.footerText =
        "深圳蜂点科技有限公司粤ICP备18073970号-1 <br />地址： 深圳市南山区南山街道南海大道西桂庙路北阳光华艺大厦1栋4楼4D16<br />联系电话：0755-26647844";
    }
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// index.vue?f8031142